const Tablet_Units = [
  {
    label: "-",
    value: "0",
  },
  {
    label: "1/2",
    value: "0.5",
  },
  {
    label: "1",
    value: "1",
  },
];
const Syrup_Units = [
  { label: "-", value: "0" },
  { label: "1 ml", value: "1" },
  { label: "2 ml", value: "2" },
  { label: "3 ml", value: "3" },
  { label: "4 ml", value: "4" },
  { label: "5 ml", value: "5" },
  { label: "6 ml", value: "6" },
  { label: "7 ml", value: "7" },
  { label: "8 ml", value: "8" },
  { label: "9 ml", value: "9" },
  { label: "10 ml", value: "10" },
  { label: "11 ml", value: "11" },
  { label: "12 ml", value: "12" },
  { label: "13 ml", value: "13" },
  { label: "14 ml", value: "14" },
  { label: "15 ml", value: "15" },
];


export const handleMedicineType = (e) => {
  if (
    e === "Tablet" ||
    e === "Capsule" ||
    e === "Ointment" ||
    e === "Injection" ||
    e === "Toothpaste" ||
    e === "Gel" ||
    e === "Others" ||
    e === "Toothbrush" ||
    e === "Gargle" ||
    e === "Tablet_Units"
  ) {
    return { type: e, units: Tablet_Units };
  } else if (e === "Syrup" || e === "Mouthwash" || e === "Syrup_Units") {
    return { type: e, units: Syrup_Units };
  } else {
    return { type: "", units: [] };
  }
};

const Units = {
  tablet: [
    { label: "-", value: "0" },
    { label: "1/2", value: "0.5" },
    { label: "1", value: "1" },
  ],
syrup: [
  { label: "-", value: "0" },
  { label: "1 ml", value: "1" },
  { label: "2 ml", value: "2" },
  { label: "3 ml", value: "3" },
  { label: "4 ml", value: "4" },
  { label: "5 ml", value: "5" },
  { label: "6 ml", value: "6" },
  { label: "7 ml", value: "7" },
  { label: "8 ml", value: "8" },
  { label: "9 ml", value: "9" },
  { label: "10 ml", value: "10" },
  { label: "11 ml", value: "11" },
  { label: "12 ml", value: "12" },
  { label: "13 ml", value: "13" },
  { label: "14 ml", value: "14" },
  { label: "15 ml", value: "15" },
],

};

export const getUnitLabel = (medicineType, value) => {
  let selectedUnits = [];
  try {
    if (
      medicineType === "Tablet" ||
      medicineType === "Capsule" ||
      medicineType === "Ointment" ||
      medicineType === "Injection" ||
      medicineType === "Toothpaste" ||
      medicineType === "Gel" ||
      medicineType === "Others" ||
      medicineType === "Toothbrush" ||
      medicineType === "Gargle" ||
      medicineType === "Tablet_Units"
    ) {
      selectedUnits = Units["tablet"];
    } else if (
      medicineType === "Syrup" ||
      medicineType === "Mouthwash" ||
      medicineType === "Syrup_Units"
    ) {
      selectedUnits = Units["syrup"];
    }

    const unit = selectedUnits.find(
      (unit) => parseFloat(unit?.value) === parseFloat(value)
    );

    return unit ? unit.label : "-";
  } catch {
    return "-";
  }
};
